/* Nutraviva lander behaviour. Progressive enhancement only: with JS off the
   page reads in full, the FAQ answers stay open, and every link still works.
   Motion is calm per the brand spec: gentle fades, no bounce, no spring. */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    if (reduced || !('IntersectionObserver' in window)) return;
    var els = (root || document).querySelectorAll('[data-nv-reveal]:not([data-nv-armed])');
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.remove('nv-hidden');
        e.target.classList.add('nv-shown');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) {
      el.setAttribute('data-nv-armed', '');
      var order = parseInt(el.getAttribute('data-nv-order') || '1', 10);
      var delay = (order - 1) * 60;
      el.style.transition = 'opacity 300ms ease-out ' + delay + 'ms, transform 300ms ease-out ' + delay + 'ms';
      /* Already on screen at load: never hide it, so there is no flash. */
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
      el.classList.add('nv-hidden');
      io.observe(el);
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('[data-nv-faq]:not([data-nv-bound])').forEach(function (faq) {
      faq.setAttribute('data-nv-bound', '');
      faq.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-nv-faq-trigger]');
        if (!trigger) return;
        var item = trigger.closest('[data-nv-faq-item]');
        var open = item.getAttribute('data-open') === 'true';
        if (faq.getAttribute('data-nv-faq') === 'single') {
          faq.querySelectorAll('[data-nv-faq-item]').forEach(function (i) {
            i.setAttribute('data-open', 'false');
            i.querySelector('[data-nv-faq-trigger]').setAttribute('aria-expanded', 'false');
          });
        }
        item.setAttribute('data-open', open ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  function boot(root) { initReveals(root); initFaq(root); }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  if (document.readyState !== 'loading') boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
